import styled from 'styled-components';

type ThProps = {
	width: string;
};

export const Th = styled.th<ThProps>`
	width: ${({ width }) => width};
	padding: 10px 0px 5px 0;
	text-align: left;
`;

export const Td = styled.td`
	padding: 0 10px 0 0;
`;
